// import React from "react";
// import {
//   FaHandshake,
//   FaCarSide,
//   FaUserTie,
//   FaHeadset,
//   FaCheck,
// } from "react-icons/fa";


// const careers = [
//   {
//     icon: <FaHandshake />,
//     title: "Business Partner",
//     description:
//       "Partner with Om Sai Cab and expand your transportation business with our growing cab service network.",
//     points: [
//       "Long-Term Partnership",
//       "Fleet Growth Support",
//       "High Earning Opportunities",
//     ],
//   },
//   {
//     icon: <FaCarSide />,
//     title: "Driver Partner",
//     description:
//       "Join Om Sai Cab as a driver partner and earn with flexible timings and regular ride bookings.",
//     points: [
//       "Commercial License Preferred",
//       "Flexible Working Hours",
//       "Daily & Weekly Earnings",
//     ],
//   },
//   {
//     icon: <FaUserTie />,
//     title: "Booking Executive",
//     description:
//       "Assist customers with cab bookings, trip planning, and customer coordination professionally.",
//     points: [
//       "Office & Remote Work",
//       "Incentive Opportunities",
//       "Customer Handling Skills",
//     ],
//   },
//   {
//     icon: <FaHeadset />,
//     title: "Customer Support",
//     description:
//       "Provide booking support, handle customer queries, and maintain smooth ride operations.",
//     points: [
//       "Professional Work Environment",
//       "Flexible Shift Timing",
//       "Career Growth",
//     ],
//   },
// ];

// const CareerSection = () => {
//   return (
//     <>
//       {/* Breadcrumb */}
  
//       <div className="breadcrumb-bar text-center">
//         <h2 className="text-white">Career</h2>
//       </div>
//       {/* Career Section */}
      // <section className="career-section">
      //   <div className="container">

      //     {/* Heading */}
      //     <div className="career-header">
      //       <h2>
      //         Career At <span>Om Sai Cab</span>
      //       </h2>

      //       <p>
      //         Build your future with Om Sai Cab as a Driver Partner,
      //         Business Partner, Booking Executive, or Customer Support Executive.
      //       </p>
      //     </div>

      //     {/* Cards */}
      //     <div className="career-grid">
      //       {careers.map((item, index) => (
      //         <div className="career-card" key={index}>

      //           <div className="career-icon">
      //             {item.icon}
      //           </div>

      //           <h3>{item.title}</h3>

      //           <p>{item.description}</p>

      //           <ul>
      //             {item.points.map((point, i) => (
      //               <li key={i}>
      //                 <FaCheck className="check-icon" />
      //                 {point}
      //               </li>
      //             ))}
      //           </ul>

      //         </div>
      //       ))}
      //     </div>

      //   </div>
      // </section>
//     </>
//   );
// };

// export default CareerSection;












import React, { useState } from "react";
import {
  FaHandshake,
  FaCarSide,
  FaUserTie,
  FaHeadset,
  FaCheck,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaPaperPlane,
  FaUser,
} from "react-icons/fa";

/* ================= CAREER DATA ================= */
const careers = [
  {
    icon: <FaHandshake />,
    title: "Business Partner",
    description:
      "Partner with Om Sai Cab and expand your transportation business with our growing cab service network.",
    points: [
      "Long-Term Partnership",
      "Fleet Growth Support",
      "High Earning Opportunities",
    ],
  },
  {
    icon: <FaCarSide />,
    title: "Driver Partner",
    description:
      "Join Om Sai Cab as a driver partner and earn with flexible timings and regular ride bookings.",
    points: [
      "Commercial License Preferred",
      "Flexible Working Hours",
      "Daily & Weekly Earnings",
    ],
  },
  {
    icon: <FaUserTie />,
    title: "Booking Executive",
    description:
      "Assist customers with cab bookings, trip planning, and customer coordination professionally.",
    points: [
      "Office & Remote Work",
      "Incentive Opportunities",
      "Customer Handling Skills",
    ],
  },
  {
    icon: <FaHeadset />,
    title: "Customer Support",
    description:
      "Provide booking support, handle customer queries, and maintain smooth ride operations.",
    points: [
      "Professional Work Environment",
      "Flexible Shift Timing",
      "Career Growth",
    ],
  },
];


/* ================= MAIN COMPONENT ================= */
const CareerSection = () => {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const number = "919594849797";

    const message = `🚖 Career / Contact Inquiry

👤 Name: ${form.name}
📞 Phone: ${form.phone}
📧 Email: ${form.email}
💬 Message: ${form.message}

Please contact me regarding opportunities.`;

    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <>
      {/* ================= HEADER ================= */}
      <div className="breadcrumb-bar text-center">
        <h2 className="text-white">Career </h2>
      </div>

      {/* ================= CAREER SECTION ================= */}
      <section className="career-section">
        <div className="container">

          <div className="career-header">
            <h2>
              Career At <span>Om Sai Cab</span>
            </h2>
            <p>
              Join us as Driver, Business Partner, Booking Executive or Support Team.
            </p>
          </div>

          <div className="career-grid">
            {careers.map((item, index) => (
              <div className="career-card" key={index}>
                <div className="career-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>

                <ul>
                  {item.points.map((p, i) => (
                    <li key={i}>
                      <FaCheck className="check-icon" /> {p}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= CONTACT SECTION ================= */}
      <section className="contact-modern">
        <div className="container">

          <div className="contact-title">
            <h2>Contact Us</h2>
            <p>We are available 24/7 for bookings & support</p>
          </div>

          <div className="contact-wrapper">

            {/* LEFT INFO */}
            <div className="contact-card info-card">

              <h3>Get In Touch</h3>

              <div className="info-item">
                <FaMapMarkerAlt />
                <span>
                  Shree Vishal CHS Ltd., Office -13 Plot No.17, Sector 18,
                  Kopar Khairane, Navi Mumbai, Maharashtra 400709
                </span>
              </div>

              <div className="info-item">
                <FaPhone />
                <span>+91 9594849797</span>
              </div>

              <div className="info-item">
                <FaEnvelope />
                <span>booking@omsaicabservice.com</span>
              </div>

              <button
                className="whatsapp-btn"
                onClick={() =>
                  window.open("https://wa.me/919594849797", "_blank")
                }
              >
                <FaWhatsapp /> Chat on WhatsApp
              </button>
            </div>

            {/* RIGHT FORM */}
            <div className="contact-card form-card">

              <h3>Send Message</h3>

              <form onSubmit={handleSubmit}>

                <div className="input-box">
                  <FaUser />
                  <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-box">
                  <FaPhone />
                  <input
                    type="text"
                    name="phone"
                    placeholder="Phone Number"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="input-box">
                  <FaEnvelope />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={handleChange}
                    required
                  />
                </div>

                <textarea
                  name="message"
                  placeholder="Write message..."
                  onChange={handleChange}
                  required
                />

                <button type="submit" className="submit-btn">
                  <FaPaperPlane /> Send on WhatsApp
                </button>

              </form>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default CareerSection;